import React, { useState } from 'react';

const TestEmail = ({ onSwitchView }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSendEmail = async (e) => {
    e.preventDefault();
    if (!email) {
      setStatus({ type: 'error', text: 'Please enter an email address.' });
      return;
    }

    setLoading(true);
    setStatus(null);

    try {
      const response = await fetch('/api/test-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ to: email })
      });

      const data = await response.json();

      if (data.status === 'success') {
        setStatus({ type: 'success', text: `Email sent successfully! Message ID: ${data.messageId}` });
      } else {
        setStatus({ type: 'error', text: data.message || 'Failed to send email' });
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus({ type: 'error', text: 'An error occurred while sending the email.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', backgroundColor: '#f9fafb' }}>
      <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#111827' }}>Mailtrap Test</h2>
        <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '20px', fontSize: '14px' }}>
          Enter an email address to send a test email using Mailtrap sandbox.
        </p>

        {status && (
          <div style={{
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '4px',
            backgroundColor: status.type === 'error' ? '#fee2e2' : '#d1fae5',
            color: status.type === 'error' ? '#991b1b' : '#065f46',
            fontSize: '14px',
            wordBreak: 'break-all'
          }}>
            {status.text}
          </div>
        )}

        <form onSubmit={handleSendEmail} style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '8px', fontWeight: '500', color: '#374151' }}>Recipient Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="test@example.com"
            required
            style={{
              padding: '10px',
              marginBottom: '20px',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '12px',
              backgroundColor: loading ? '#9ca3af' : '#4f46e5',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s'
            }}
          >
            {loading ? 'Sending...' : 'Send Test Email'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default TestEmail;
